export const getPivotChartArray = (data = [], row, column, value, addRow, financialYear) => {

    var item = data.reduce((a, b) => {
        a[b[row]] = a[b[row]] || [];
        var obj = {};
        obj[addRow] = b[addRow] ? b[addRow] : 0;
        addRow
            ? a[b[row]].push({ ...obj, ...{ [b[column]]: (b[value]) } })
            : a[b[row]].push({ ...{ [b[column]]: (b[value]) } });
        return a;
    }, {});


    var array = Object.keys(item).map(function (k) {
        return { [row]: k, ...Object.assign.apply({}, item[k]) };
    });
    return array.sort();
};

export function toMillion(value) {
    if (value < 0) {

        return Math.abs(Number(value)) >= 1.0e9
            ? "$" + -(Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M"
            : // Six Zeroes for Millions
            Math.abs(Number(value)) >= 1.0e6
                ? "$" + -(Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M"
                : // Three Zeroes for Thousands
                Math.abs(Number(value)) >= 1.0e3
                    ? "$" + -(Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M"
                    : "$" + -(Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M";
    } else {
        return Math.abs(Number(value)) >= 1.0e9
            ? "$" + (Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M"
            : // Six Zeroes for Millions
            Math.abs(Number(value)) >= 1.0e6
                ? "$" + (Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M"
                : // Three Zeroes for Thousands
                Math.abs(Number(value)) >= 1.0e3
                    ? "$" + (Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M"
                    : "$" + (Math.abs(Number(value)) / 1.0e6).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "M";
    }
}

export const convertIntoCommaSeperated = (value) => {
    return Number(value)?.toLocaleString()
}


export function FormatNum(value, { locale, min, max }) {
    return value?.toLocaleString(locale, { minimumFractionDigits: min || 0, maximumFractionDigits: max || 0 })
}

export function toTitleCase(input) {
    let formattedString = input.replace(/_/g, ' ');
    formattedString = formattedString.split(/\s+/).map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');

    return formattedString;
}


export function toCustomTitleCase(text) {
    const keepLowerCase = new Set(["of", "and", "at", "in", "as"]);

    return text
        .split(" ")
        .map((word, index) =>
            index === 0 || !keepLowerCase.has(word.toLowerCase())
                ? word == "ELA" || word=='(IREADY' ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word.toLowerCase()
        )
        .join(" ");
}

export function format(value, options = {}) {
    let _value = value;

    // Validate number
    if (typeof value !== "number" || isNaN(value)) return "-";

    // Format to thousand/million/billion
    switch (options.format) {
        case "thousand":
            _value = _value / 1_000;
            break;
        case "million":
            _value = _value / 1_000_000;
            break;
        case "billion":
            _value = _value / 1_000_000_000;
            break;
        case "raw":
        default:
            break;
    }

    // Clone options to avoid mutating original
    const formatOptions = { ...options };

    // Apply forcedecimals override
    if (typeof options.forcedecimals === "number") {
        formatOptions.minimumFractionDigits = options.forcedecimals;
        formatOptions.maximumFractionDigits = options.forcedecimals;
    }

    // Handle prefix/suffix safely
    const prefix = options.prefix ?? "";
    const suffix = options.suffix ?? "";

    // Format number
    const formatted = _value.toLocaleString(options.locales, formatOptions);
    return `${prefix}${formatted}${suffix}`;
};

export function getMetricDisplayValue(cy_value, py_value, metricGroup) {
    const isPreviousYearFallbackGroup = ["Graduation", "Assessment"].includes(
        metricGroup
    );

    const value = Number(cy_value ?? 0);
    const pyValue = Number(py_value ?? 0);

    // Graduation / Assessment
    if (isPreviousYearFallbackGroup) {
        if (value !== 0) {
            return value;
        }

        if (pyValue !== 0) {
            return pyValue;
        }

        return null; // will display "-"
    }

    // All other metric groups
    return value !== 0 ? value : null;
};
